// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ONWe","inner":"styles_inner__1pMWU","right":"styles_right__2joii","close":"styles_close__2DNyK","footer":"styles_footer__2yzVe"};